import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from '../../../models/utilities/filter-bar';
import { ListColumn, SelectedSort } from '../../../models/utilities/list-header';
import { PageData } from '../../../models/utilities/paged-request';
import { SelectListItem } from '../../../models/utilities/selectlist-item';
import { ApiEndpoints, GlobalConstants } from '../../../utils/app-constants';
import { AppUtils } from '../../../utils/app-utils';
import { carrierSelectList } from '../../selectors';
import { ShipmentType } from '../enums/_index';
import { ShipmentStatusMetadata } from '../enums/shipment-status';

export class ContainerSearchFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl          : string = ApiEndpoints.TRANSPORTATION_CONTAINERS_SEARCH;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[] = [];
    public selectedSort     : SelectedSort;
    
    constructor(columnNames: string[] = [], filterNames: string[] = []) {

        const listColumns: any = {
            'containerId': new ListColumn('Container ID', 'id', true),
            'status': new ListColumn('Status', ''),
            'name': new ListColumn('Name', 'name', true),
            'cutoff': new ListColumn('Cutoff', 'cutoff', true),
            'departureTime': new ListColumn('Departure Time', 'date', true),
            'psSent': new ListColumn('Production Summary', 'psSent', true),
            'pdSent': new ListColumn('Preliminary Delivery', 'pdSent', true),
            'fdSent': new ListColumn('Final Delivery', 'fdSent', true),
        }

        if (columnNames.length == 0) {
            for (let column in listColumns) {
                this.columns.push(listColumns[column]);
            }
        }
        else {
            for (let columnName of columnNames) {
                if (listColumns[columnName]) {
                    this.columns.push(listColumns[columnName])
                }
            }
        }

        const filterGroups: any = {
            'byStatus': this.buildStatus(),
            'byCutoff': this.buildCutoffDate(),
            'byContainerId': this.buildContainerId(),
            'byDealer': this.buildDealer(),
            'byOrderId': this.buildOrderId(),
            'byDate': this.buildDeliveryDate(),
            'byName': this.buildContainerName(),            
            'byCarrier': this.buildCarrier(),
            'byNumber': this.buildNumber()
        };

        if (filterNames.length == 0) {
            for (let group in filterGroups) {
                this.filters.push(filterGroups[group]);
            }
        }
        else {
            for (let filterName of filterNames) {
                if (filterGroups[filterName]) {
                    this.filters.push(filterGroups[filterName])
                }
            }
        }

        // Create our Non-Optional Filters
        const byType = this.buildType();
        this.requiredFilters.push(byType);
    }

    // #region Group Builders

    private buildStatus() {        
        const byStatus = new FilterGroup('Status', 'checkboxes', 'status');
        byStatus.opts = AppUtils.enumMetadataToFilters(ShipmentStatusMetadata);

        byStatus.opts.forEach((itm : FilterBarInputOpt) => {
            itm.data = (itm.qsValue === 0) ? true : false;
        });

        byStatus.opts = byStatus.opts.filter((itm : FilterBarInputOpt) => {
            return itm.qsValue >= 0;
        });

        return byStatus;
    }

    private buildDeliveryDate() {
        const byDate = new FilterGroup('Delivery Date', 'date', 'date');        
        const opt1 = new FilterBarInputOpt('Delivery Date', undefined);
        
        byDate.opts = [opt1];

        return byDate;
    }

    private buildDealer() {
        const byDealer = new FilterGroup('Dealer', 'dealer', 'dealer');        
        const opt1 = new FilterBarInputOpt('Dealer', '');
        
        byDealer.opts = [opt1];

        return byDealer;
    }

    private buildOrderId() {
        const byOrderId = new FilterGroup('Order ID', 'text', 'order');        
        const opt1 = new FilterBarInputOpt('Order ID', '');
        
        byOrderId.opts = [opt1];

        return byOrderId;
    }

    private buildContainerId() {
        const byContainerId = new FilterGroup('Container ID', 'numeric', 'id');        
        const opt1 = new FilterBarInputOpt('Container ID', '');
        
        byContainerId.opts = [opt1];

        return byContainerId;
    }

    private buildContainerName() {
        const byTruckName = new FilterGroup('Name', 'text', 'name');
        const opt1 = new FilterBarInputOpt('Name', '');
        
        byTruckName.opts = [opt1];

        return byTruckName;
    }

    private buildType() {
        // Force container type
        const requiredType      = new AppliedFilterBarOpt();
        requiredType.uuid       = '';
        requiredType.label      = 'By Container';
        requiredType.qsName     = 'type';
        requiredType.qsValue    = ShipmentType.Container.toString(); 

        return requiredType;
    }

    private buildCutoffDate() {
        const byDate = new FilterGroup('Cutoff Date', 'date', 'cutoff');        
        const opt1 = new FilterBarInputOpt('Cutoff Date', undefined);
        
        byDate.opts = [opt1];

        return byDate;
    }
    
    private buildCarrier() {
        
        const byCarrier = new FilterGroup('Carrier', 'dropdown', 'carrier');

        const opts : FilterBarInputOpt[] = [];
        const carriers = carrierSelectList();        
        carriers.forEach((itm : SelectListItem<string>) => {
            opts.push(new FilterBarInputOpt(
                itm.name, 
                false, 
                itm.id
            ));
        });

        byCarrier.opts = opts;
        return byCarrier;
    }    

    private buildNumber() {
        const byNumber = new FilterGroup('Number', 'text', 'number');        
        const opt1 = new FilterBarInputOpt('Number', '');
        
        byNumber.opts = [opt1];

        return byNumber;
    }

    // #endregion

}
